// A dropdown menu for selecting teams.
// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import SearchableDropDown from './SearchableDropDown';

import type { Suggestion } from './dropdown/constants';
import { ORG_LOGO_BASE_URL } from './dropdown/constants';

export const DEFAULT_ALL_TEAMS_TEXT = 'All Athletes';

export type TeamSelectionProps = {
    data: any,
    onSelect?: () => void,
    selectedId?: number,
    orgId?: number,
    allOptionText?: string
};

export class TeamSelectionStandalone extends PureComponent<TeamSelectionProps> {
    static defaultProps = {
        selectedId: 0,
        onSelect: () => {},
        allOptionText: DEFAULT_ALL_TEAMS_TEXT
    };

    getTransformedDataSet = () => {
        const { data: teams, selectedId, orgId } = this.props;

        let selected = 0;

        // Because we are injecting the ALL option, we have to
        // handle pointing to the correct index of the data array
        // that is built below. The allOffset starts off assuming
        // nothing has been selected. Once something has been
        // selected, the allOffset is set to 1 to account for the
        // all option being injected before the rest of the passed
        // in options.
        let allOffset = 0;

        let allTeamsOption = {
            text: this.props.allOptionText,
            image: `${ORG_LOGO_BASE_URL}/${orgId}`,
            allOption: true
        };

        let data: Array<Suggestion> = [allTeamsOption];

        // Massage the data to adhere to the Suggestion API.
        for (let i = 0; i < teams.length; i++) {
            const { id, title, logo } = teams[i];

            if (id === selectedId) {
                selected = i;
                allOffset = 1;
            }

            data.push({
                id,
                text: title,
                image: logo
            });
        }

        return {
            data,
            selected,
            allOffset
        };
    };

    render() {
        const { data, selected, allOffset } = this.getTransformedDataSet();
        return (
            <div className="fixed-width-dropdown">
                <SearchableDropDown
                    data={data}
                    selected={data[selected + allOffset]}
                    onSelect={this.props.onSelect}
                />
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        data: state.library.teamsTree,
        orgId: state.app.loggedInUser.org_id
    };
};

export default connect(mapStateToProps)(TeamSelectionStandalone);



// WEBPACK FOOTER //
// ./src/view/common/TeamSelection.jsx